import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  FaLaptopCode,
  FaMobileAlt,
  FaPalette,
  FaCogs,
  FaRocket,
} from "react-icons/fa";

export default function Soft() {
  const navigate = useNavigate();

  const services = [
    {
      icon: <FaLaptopCode />,
      title: "E-Commerce",
      desc: "High-performance online stores with seamless checkout.",
    },
    {
      icon: <FaMobileAlt />,
      title: "Web Apps",
      desc: "Scalable apps with real-time data & APIs.",
    },
    {
      icon: <FaPalette />,
      title: "Admin Panels",
      desc: "Clean dashboards with insights & automation.",
    },
    {
      icon: <FaCogs />,
      title: "Portfolios",
      desc: "Minimal brand-focused websites.",
    },
    {
      icon: <FaRocket />,
      title: "Corporate",
      desc: "Enterprise-ready modern websites.",
    },
  ];

  return (
    <div className="bg-white text-gray-900 min-h-screen">
      <Header />

      {/* 🔥 HERO (CLEAN) */}
      <section className="max-w-6xl mx-auto px-6 py-24 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight leading-tight">
            Build modern digital products
          </h1>

          <p className="mt-5 text-gray-500 max-w-xl mx-auto">
            We design and develop clean, scalable websites that grow your business.
          </p>

          <button
            onClick={() => navigate("/contact")}
            className="mt-8 px-8 py-3 bg-black text-white rounded-full font-semibold hover:opacity-80 transition"
          >
            Start Project
          </button>
        </motion.div>
      </section>

      {/* 💎 SERVICES (MINIMAL GRID) */}
      <section className="max-w-6xl mx-auto px-6 pb-24 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((s, i) => (
          <motion.div
            key={i}
            whileHover={{ y: -4 }}
            className="group p-6 rounded-2xl border border-gray-200 hover:border-gray-300 transition bg-white"
          >
            <div className="text-2xl text-gray-800 mb-4">
              {s.icon}
            </div>

            <h3 className="text-lg font-semibold mb-2">
              {s.title}
            </h3>

            <p className="text-sm text-gray-500">
              {s.desc}
            </p>

            <button
              onClick={() => navigate("/quotes")}
              className="mt-4 text-sm text-black font-medium hover:underline"
            >
              Learn more →
            </button>
          </motion.div>
        ))}
      </section>

      {/* 🚀 CTA (CLEAN) */}
      <section className="border-t border-gray-200 py-20 text-center">
        <h2 className="text-3xl font-semibold">
          Ready to start your project?
        </h2>

        <button
          onClick={() => navigate("/contact")}
          className="mt-6 px-8 py-3 bg-black text-white rounded-full font-semibold hover:opacity-80 transition"
        >
          Contact Us
        </button>
      </section>

      <Footer />
    </div>
  );
}